export enum ViewState {
  LOADING,
  OK,
  ERROR,
  EMPTY,
}
